import React, { Component } from 'react'
import * as d3Axis from 'd3-axis'
import { select as d3Select } from 'd3-selection'

import "./css/Axis.css"

export default class Axis extends Component {
    componentDidMount() {
        this.renderAxis()
    }

    componentDidUpdate() {
        this.renderAxis()
    }

    renderAxis() {
        const axisType = `axis${this.props.orient}`;
        const axis = d3Axis[axisType]()
            .scale(this.props.scale)
            .tickSize(-this.props.tickSize)
            .tickPadding([10])
            .ticks([5]);


        let tickaxis = d3Select(this.axisElement).call(axis);
        if (this.props.orient === "Bottom" && !this.props.show_ticks.showx) {
            //tickaxis.selectAll("text").remove();
        } else if (this.props.orient === "Left" && !this.props.show_ticks.showY) {
            console.log("left ticks")
            if (tickaxis.selectAll("text")._groups[0].length > 20) {
                tickaxis.selectAll("text").remove();
            }


        }
    }


    render() {
        return (
            <g
                className={`Axis Axis-${this.props.orient}`}
                ref={(el) => { this.axisElement = el; }}
                transform={this.props.translate}
            />
        )
    }
}